/**
 * How a host drives the editors: with a mouse (`pointer`, the web) or a
 * finger (`touch`, Kai Pro). Each host sets it once, on the editor and
 * assembler state and on its 3D cores. The mouse sizes are the reference and
 * the default. Under touch every target is the 44 pt square centered on its
 * visual center, so each reach and spacing the platforms share reads this
 * one setting rather than a size of its own per platform.
 */
export type InputKind = 'pointer' | 'touch';

/** The least a touch target measures each way (px, Apple's 44 pt). */
export const MIN_TOUCH_TARGET_PX = 44;

/** How far a touch target reaches from its visual center, or either side of its line (px): half the 44 pt square. */
export const TOUCH_TARGET_REACH = MIN_TOUCH_TARGET_PX / 2;

/** Whether a touch at `point` lands on the touch target about `center`: the 44 pt square centered there. */
export const withinTouchTarget = (point: { x: number; y: number }, center: { x: number; y: number }): boolean =>
  Math.abs(point.x - center.x) <= TOUCH_TARGET_REACH && Math.abs(point.y - center.y) <= TOUCH_TARGET_REACH;
